import React, { Children } from 'react';
import { motion } from 'framer-motion';
const painPoints = ['Pasás horas buscando materiales en Pinterest o YouTube', 'Descargás recursos desordenados que no combinan entre sí', 'Tenés alumnos con distintos niveles y no sabés cómo adaptar actividades', 'Te sentís agotada armando actividades desde cero', 'No encontrás materiales realmente inclusivos y visuales', 'Necesitás captar la atención del niño y no sabés cómo', 'Querés ayudar más… pero no te alcanza el tiempo'];
export function ProblemSection() {
  return <section className="w-full bg-[#FFF8F0] py-16 sm:py-24 px-4" data-id="element-172">
      <div className="max-w-2xl mx-auto" data-id="element-173">
        <motion.div className="text-center mb-10 sm:mb-14" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5
      }} data-id="element-174">
          <div className="inline-flex items-center justify-center w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-[#FFB5C5]/20 text-[#FFB5C5] mb-4 sm:mb-6" data-id="element-175">
            <svg className="w-6 h-6 sm:w-8 sm:h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-176">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" data-id="element-177" />
            </svg>
          </div>
          <h2 className="text-2xl sm:text-4xl font-black text-[#3D3935] mb-4 leading-tight" data-id="element-178">
            EL PROBLEMA REAL
          </h2>
          <p className="text-[#8B7E76] text-sm sm:text-lg font-medium" data-id="element-179">
            Si trabajás con niños con dificultades de aprendizaje, esto
            seguramente te pasa:
          </p>
        </motion.div>

        <motion.div className="space-y-3 sm:space-y-4 mb-10 sm:mb-14" initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-40px'
      }} variants={{
        hidden: {},
        visible: {
          transition: {
            staggerChildren: 0.1
          }
        }
      }} data-id="element-180">
          {painPoints.map((point, i) => <motion.div key={i} variants={{
          hidden: {
            opacity: 0,
            x: -20
          },
          visible: {
            opacity: 1,
            x: 0,
            transition: {
              duration: 0.4,
              ease: 'easeOut'
            }
          }
        }} className="flex items-start gap-3 sm:gap-4 bg-white border border-[#EFE3D4] p-4 sm:p-5 rounded-xl sm:rounded-2xl shadow-sm hover:shadow-md transition-shadow" data-id="element-181">
              <div className="flex-shrink-0 w-6 h-6 sm:w-7 sm:h-7 rounded-full bg-[#FF6B6B]/10 flex items-center justify-center mt-0.5" data-id="element-182">
                <span className="text-[#FF6B6B] text-xs sm:text-sm" data-id="element-183">❌</span>
              </div>
              <p className="text-[#3D3935] text-sm sm:text-base font-semibold leading-snug sm:leading-relaxed pt-0.5" data-id="element-184">
                {point}
              </p>
            </motion.div>)}
        </motion.div>

        <motion.div className="text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} data-id="element-185">
          <p className="text-lg sm:text-2xl font-black text-[#F5A04B]" data-id="element-186">
            ¿Cuántas noches más vas a seguir improvisando materiales?
          </p>
        </motion.div>
      </div>
    </section>;
}